<script lang="ts" setup>
const props = defineProps({
  isSm: Boolean,
  isLg: Boolean,
  isXl: Boolean,
  yellow: Boolean,
  primary: Boolean
})

const sizeClasses = computed<string>(() => {
  if (props.isSm) {
    return 'w-4 h-4 border-2'
  }

  if (props.isLg) {
    return 'w-8 h-8 border-4'
  }

  if (props.isXl) {
    return 'w-12 h-12 border-8'
  }

  return 'w-5 h-5 border-2'
})
</script>

<template>
  <div class="spinner" :class="[sizeClasses, { primary, yellow }]" />
</template>

<style scoped>
.spinner {
  top: 0;
  display: block;
  border-radius: 9999px;
  border-color: transparent;
  background-color: transparent;
  border-top-color: var(--color-white);
  border-right-color: var(--color-white);

  animation-name: spin;
  animation-duration: 800ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.spinner:not(.m-0, .mr-0) {
  margin-left: auto;
  margin-right: auto;
}

.spinner:not(.mr-0) {
  left: 0;
}

.primary {
  border-top-color: var(--color-green-600);
  border-right-color: var(--color-green-600);
  border-bottom-color: var(--color-green-600);
}

.yellow {
  border-top-color: var(--color-yellow-500);
  border-right-color: var(--color-yellow-500);
  border-bottom-color: var(--color-yellow-500);
}
</style>
